
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "arrow-right.icon",
  "use": "arrow-right.icon-usage",
  "viewBox": "0 0 7 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 13\" id=\"arrow-right.icon\"><g id=\"arrow-right.icon_List-product\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"arrow-right.icon_Page-Product-result\" transform=\"translate(-1128 -859)\" fill=\"#FFF\"><g id=\"arrow-right.icon_Group-3-Copy-3\" transform=\"translate(214 498)\"><path d=\"M918.648 367.75l-4.566-4.758c-.146-.146-.146-.291 0-.437l.82-.82c.164-.146.31-.156.438-.028l5.578 5.824a.296.296 0 01.082.219.296.296 0 01-.082.219l-5.578 5.824c-.146.146-.292.146-.438 0l-.82-.848c-.146-.146-.146-.291 0-.437l4.566-4.758z\" id=\"arrow-right.icon_ion-chevron-right---Ionicons\" /></g></g></g></symbol>"
});
    sprite.add(symbol);
    export default class ArrowRightIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="arrow-right.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/arrow-right.icon.svg